package one.healthium.content.navigation.media

import com.arkivanov.decompose.ComponentContext

class DefaultVideoPlayerComponent(
    componentContext: ComponentContext,
    override val url: String,
    private val onBackClicked: () -> Unit,
) : VideoPlayerComponent, ComponentContext by componentContext {
    override fun onBackClicked() {
        onBackClicked.invoke()
    }
}